module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_arrow_right_black-3b1aa6ccbfdcaf8614d9a5c5adb83dfa.svg";